/**
 * Slice "manualPayloads" dello state Pinia del promo-engine.
 * Mantiene i payload e ultimi risultati
 * relativi ai flussi MANUAL (estimate/apply/confirm).
 */

export type ManualPayloadsState = {
  manualPromoList: any[] // aggiornare con api corretta ESTIMATE
  consumerCampaigns: any[] // aggiornare con api corretta consumerCampaigns
  currentManualPreview: {
    items: any[]
    costs: any[]
    promo: any[]
  }
  manualModalShown: boolean
  currentEstimate: {
    input: unknown | null
    output: [] | null
    rule_engine_version: string | null
    maxed_out_promotions: unknown
  }
}

export const createManualPayloadsState = (): ManualPayloadsState => ({
  manualPromoList: [],
  consumerCampaigns: [],
  currentManualPreview: {
    items: [],
    costs: [],
    promo: [],
  },
  manualModalShown: false,
  currentEstimate: {
    input: {},
    output: [],
    rule_engine_version: '',
    maxed_out_promotions: {},
  },
})
